export default __webpack_public_path__ + "static/logo-black-0372c0641ba5b985a967ab4293441fb9.png";